import { createSurveyStyles } from '@sm/webassets';
import { SurveyThemeType } from '@sm/webassets/dist/components/SurveyTheme';

const useSurveyStyles = createSurveyStyles<'surveyTitle', { align: string }>((theme: SurveyThemeType) => ({
  surveyTitle: {
    color: theme?.titleColor || '#00bf6f',
    lineHeight: 1.25,
    paddingBottom: 24,
    textAlign: ({ align }) => align.toLowerCase(),
    ...theme?.surveyTitle,
    // reset font weight changed by the theme above
    '& strong': {
      fontWeight: 'bold !important',
    },
  },
}));

export default useSurveyStyles;
